import React from 'react'

const Card = ({ children, classNames }) => {
    return <div className={`border rounded-md shadow-md p-24 bg-bg-grey ${classNames}`}>{children}</div>
}

export default Card